
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, WifiOff } from 'lucide-react';

interface ConnectionErrorMessageProps {
  error: unknown;
  isRetrying: boolean;
  onRetry: () => void;
}

const ConnectionErrorMessage: React.FC<ConnectionErrorMessageProps> = ({ 
  error, 
  isRetrying, 
  onRetry 
}) => {
  if (!error) return null;
  
  return (
    <div className="bg-white rounded-lg shadow p-8 mb-6">
      <div className="flex flex-col items-center justify-center text-center space-y-4">
        <WifiOff className="h-12 w-12 text-destructive" />
        <h2 className="text-xl font-semibold">Cannot connect to database</h2>
        <p className="text-muted-foreground max-w-md">
          Unable to load staff data. Please check your connection to Supabase or try again later.
        </p>
        <Button 
          onClick={onRetry} 
          className="mt-2"
          disabled={isRetrying}
        >
          <RefreshCw className={`mr-2 h-4 w-4 ${isRetrying ? 'animate-spin' : ''}`} />
          {isRetrying ? 'Retrying...' : 'Retry Connection'}
        </Button>
      </div>
    </div>
  );
};

export default ConnectionErrorMessage;
